<template>
  <UCard
    class="-mx-4 lg:mx-0 mt-3 md:mt-8 !bg-neutral-100 dark:!bg-neutral-950 overflow-hidden dark:text-white p-2 sm:p-4 lg:p-10"
  >
    <div class="flex flex-col lg:flex-row items-center gap-10 mb-10">
      <HeadingBasic :size="2" class="text-neutral-950 dark:text-white">
        NCAA Percentile Rankings
      </HeadingBasic>
      <FiltersYearRadio v-model="barYear" />
    </div>
    <div class="lg:flex gap-10 w-full lg:gap-20">
      <DataRankingsSection
        sectionTitle="Pitching"
        :data="pitchingBarData"
        :yearAvailable="barYearPitching"
        :year="barYear"
        :type="type"
        :restricted="restricted"
      />
      <DataRankingsSection
        sectionTitle="Hitting"
        :data="hittingBarData"
        :yearAvailable="barYearHitting"
        :year="barYear"
        :show-divider="!!(pitchingRankings && pitchingRankings.length)"
        isLastSection
        :type="type"
        :restricted="restricted"
      />
    </div>
    <div v-if="!pitchingRankings?.length && !hittingRankings?.length">
      <HeadingBasic class="text-neutral-900 dark:text-white" :size="4">
        No rankings available
      </HeadingBasic>
    </div>
  </UCard>
</template>

<script lang="ts" setup>
import { useVModels } from '@vueuse/core';
// Define props if any data is being passed into this component from a parent component
const props = defineProps<{
  pitchingBarData?: any[];
  hittingBarData?: any[];
  barYearPitching?: boolean;
  barYearHitting?: boolean;
  pitchingRankings?: any[];
  hittingRankings?: any[];
  barYear: number;
  restricted?: boolean;
  type: 'player' | 'team';
}>();

// If 'barYear' is being modified within this component and needs to be synced with the parent,
// you can use 'emit' to handle the two-way binding.
const { emit } = defineEmits(['update:barYear']);
const { barYear } = useVModels(props, emit);

// Include any other setup code, methods, computed properties, or lifecycle hooks as needed
</script>

<style scoped>
/* Add component-specific styles here */
</style>
